var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('p',{staticClass:"rounded py-1 px-3 text-white text-xs",style:("background-color:"+ "" + _vm.color),domProps:{"textContent":_vm._s(_vm.taskAssignee())}})])}
var staticRenderFns = []

export { render, staticRenderFns }